import { HandledEvents } from './handled-events';
import { Command, Query } from '../../../common'

export class EmptyPhase {
  public async enter() {

  }

  public async exit() {

  }

  public handleEvent(event: HandledEvents): void {
  }

  public execute(command: Command) {
  }

  public query<T extends string, TPayload, TResult>(query: Query<T, TPayload, TResult>): Promise<TResult> {
    throw new Error('not implemented')
  }  
}
